<template>
  <div>
    <van-nav-bar title="任务列表" left-text="返回" @click-left="$router.back()" />
    <!-- 搜索框 -->
    <div class="search-container">
     <van-search
       v-model="searchKeyword"
       placeholder="请输入地址关键词"
       @search="onSearch"
       @clear="onClear"
       shape="round"
       background="#f5f5f5"
       show-action
     >
       <div slot="action" @click="onSearch">搜索</div>
     </van-search>
    </div>
    <div class="basic-list">
      <!-- 使用 vant 的 Cell 组件展示列表项 -->
      <van-cell-group>
        <van-cell v-for="(item, index) in listData" :key="index" :title="item.title" :value="getStateText(item.state)" :class="getStateClass(item.state)" :label="item.address" is-link
          @click="goDetail(item)" />
      </van-cell-group>

      <!-- 详情弹窗 -->
      <van-popup v-model="showPopup" position="bottom" :style="{ height: '60%' }">
        <div class="detail-container">
          <van-nav-bar title="详情信息" left-text="关闭" @click-left="showPopup = false" />
          <div class="success-tip" >
            任务接收成功后可在我的订单中查看联系方式
          </div>
          <div class="detail-content">
            <van-cell-group>
              <van-cell title="标题" :value="currentItem.title" />
              <van-cell title="地址" :value="currentItem.address" />
              <!-- <van-cell title="联系电话" :value="currentItem.phone" /> -->
              <van-cell title="详细描述" :value="currentItem.text" />
              <van-cell title="状态" :value="getStateText(currentItem.state)" :class="getStateClass(currentItem.state)" />
            </van-cell-group>
            </div>
          <!-- 添加接收任务按钮 -->
          <div class="button-container" v-if="currentItem.state === '1'">
            <van-button type="primary" block @click="acceptTaskCli" :loading="isAccepting">
              {{ isAccepting ? '接收中...' : '接收任务' }}
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line camelcase
import { getTaskList, acceptTask } from '@/utils/api.js'
export default {
  name: 'BasicList',
  data() {
    return {
      // 列表数据
      listData: [

      ],
      showPopup: false, // 控制详情弹窗显示
      currentItem: {}, // 当前查看的项目
      isAccepting: false, // 接收任务状态
      searchKeyword: '' // 搜索关键词
    }
  },
  methods: {
    getStateText(state) {
      console.log(state)
      console.log(typeof state)
     switch (state) {
       case '1': return '待领取';
       case '2': return '已接收';
       case '3': return '已完成';
       default: return '未知状态';
      }
    },
    // 获取状态样式类
    getStateClass(state) {
      switch (state) {
        case '1': return 'state-pending';
        case '2': return 'state-accepted';
        case '3': return 'state-completed';
        default: return '';
      }
    },
    // 搜索事件
   onSearch() {
     this.fetchTaskList();
   },
   // 清除搜索事件
   onClear() {
     this.searchKeyword = '';
     this.fetchTaskList();
   },
    // 获取任务列表
    async fetchTaskList() {
      try {
         // 构造搜索参数
         const params = {};
         if (this.searchKeyword) params.address = this.searchKeyword;
         const res = await getTaskList(params)
        this.listData = res
      } catch (error) {
        this.$toast.fail('获取任务列表失败')
      }
    },

    // 接收任务方法
    async acceptTaskCli() {
      const userInfo = localStorage.getItem('userInfo');
      if (!userInfo) {
        // 用户未登录，跳转到登录页面
        this.$toast.fail('请先登录');
        // 假设登录路由为 /login，根据实际情况调整
        this.$router.push('/login');
        return;
      }

      // 解析用户信息
      const user = JSON.parse(userInfo);

      // 检查用户名是否存在
      if (!user.name) {
        this.$toast.fail('用户信息不完整，请重新登录');
        this.$router.push('/login');
        return;
      }
      if(user.name === this.currentItem.phone){
        this.$toast.fail('不能接收自己发布的任务');
        return;
      }
      this.isAccepting = true
      try {
        // 调用实际的接收任务API
        await acceptTask({
          id: this.currentItem.id,
          get_phone: user.name
        })

        // 显示成功提示
        this.$toast.success('任务接收成功')

        // 关闭弹窗
        this.showPopup = false
        await this.fetchTaskList();
      } catch (error) {
        this.$toast.fail('任务接收失败')
      } finally {
        this.isAccepting = false
      }
    },
    // 跳转到详情页
    goDetail(item) {
      this.currentItem = item
      this.showPopup = true
    }
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.query.keyword) {
        this.searchKeyword = to.query.keyword;
        this.onSearch();
      }
    }
  },
 mounted() {
    // 页面加载时检查是否有搜索关键词参数
    if (this.$route.query.keyword) {
      this.searchKeyword = this.$route.query.keyword;
      this.onSearch();
    } else {
      this.fetchTaskList();
    }
  }
}
</script>

<style scoped>
body {
  background-color: #f5f5f5;
}

.basic-list {
  padding: 15px;
  background-color: #f5f5f5;
}

.van-cell-group {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.van-cell {
  margin-bottom: 1px;
}

.detail-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.detail-content .van-cell {
  border-radius: 6px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

h2 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin: 0;
  padding: 10px;
}

.button-container {
  padding: 20px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}
/* 状态样式 */
.state-cell .van-cell__value {
  flex: none;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
}

.state-pending .van-cell__value {
  color: #ff976a;
}

.state-accepted .van-cell__value {
  color: #1989fa;
}

.state-completed .van-cell__value {
  color: #07c160;
}

/* 弹窗中的状态样式 */
.state-pending .van-cell__value {
  color: #ff976a;
}

.state-accepted .van-cell__value {
  color: #1989fa;
}

.state-completed .van-cell__value {
  color: #07c160;
}
/* 搜索框样式 */
.search-container {
  padding: 10px;
  background-color: #fff;
 position: sticky;
 top: 0;
 z-index: 10;
}
.van-field--focus {
  border-color: #1989fa;
}
 .van-search {
  padding: 0;
  background-color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

 .van-search__action {
  color: #1989fa;
  font-weight: 500;
  padding: 0 8px;
}

 .van-field__control {
  font-size: 14px;
}
.success-tip {
 border-radius: 4px;
  padding: 10px;
  margin: 10px 15px;
  font-size: 14px;
  text-align: center;
   display: flex;
   align-items: center;
  justify-content: center;
   gap: 8px;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background-color: #e8f4ff;
  border: 1px solid #1989fa;
  color: #1989fa;
}

</style>



// WEBPACK FOOTER //
// src/components/basic-list.vue